/**
 * Container/Frame layout maps — Tailwind class lookups for container section props.
 */

/** Section types that act as layout containers (can have children). */
const CONTAINER_TYPES = new Set(['container-frame'])

/** Check if a section type is a layout container (supports nested children). */
export function isContainerType(sectionType: string): boolean {
  return CONTAINER_TYPES.has(sectionType)
}

/** Maximum nesting depth for container sections to prevent infinite recursion. */
export const MAX_CONTAINER_DEPTH = 5

export const CONTAINER_ALIGN_MAP: Record<string, string> = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
}

export const CONTAINER_JUSTIFY_MAP: Record<string, string> = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
}

export const CONTAINER_GAP_MAP: Record<string, string> = {
  none: 'gap-0',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  xl: 'gap-8',
}

export const CONTAINER_WIDTH_MAP: Record<string, string> = {
  auto: 'w-auto',
  full: 'w-full',
  fit: 'w-fit',
}

export const CONTAINER_MIN_HEIGHT_MAP: Record<string, string> = {
  none: '',
  screen: 'min-h-screen',
  '200': 'min-h-[200px]',
  '400': 'min-h-[400px]',
  '600': 'min-h-[600px]',
}

export const CONTAINER_PADDING_MAP: Record<string, string> = {
  none: '',
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
  xl: 'p-8',
}
